"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const HomepageIcon = ({ category, bgColor, path, setSelectedCategory, color, text, selectedCategory, }) => {
    const [hover, setHover] = (0, react_1.useState)(false);
    const handleMouseEnter = () => setHover(true);
    const handleMouseLeave = () => setHover(false);
    return (react_1.default.createElement("button", { className: `w-1/2 sm:w-1/3 lg:w-52 h-1/6 flex justify-center items-center`, onClick: () => setSelectedCategory(category), style: {
            backgroundColor: hover ? "#555" : selectedCategory === category ? `${bgColor}` : `${bgColor}11`,
        }, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
        react_1.default.createElement("div", { className: "w-40 h-40 flex justify-evenly items-center flex-col" },
            react_1.default.createElement("div", { className: "w-full h-16 fill-white flex justify-center items-center maskedSVG", style: {
                    maskImage: `url(${path})`,
                    WebkitMaskImage: `url(${path})`,
                    backgroundColor: hover ? "#FFFFFF" : selectedCategory === category ? `${color}` : `${bgColor}`,
                } }),
            react_1.default.createElement("span", { style: { color: hover ? "#FFFFFF" : selectedCategory === category ? `${color}` : `${bgColor}` } }, text))));
};
exports.default = HomepageIcon;
